import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import AppShell from "./layout/AppShell";
import AcceptInvitationPage from "./pages/AcceptInvitationPage";
import AdminPage from "./pages/AdminPage";
import CalendarPage from "./pages/CalendarPage";
import CustomersPage from "./pages/CustomersPage";
import DashboardPage from "./pages/DashboardPage";
import DispatchPage from "./pages/DispatchPage";
import FinancePage from "./pages/FinancePage";
import FollowUpsPage from "./pages/FollowUpsPage";
import IntelligencePage from "./pages/IntelligencePage";
import LoginPage from "./pages/LoginPage";
import InitialSetupPage from "./pages/InitialSetupPage";
import MarketingPage from "./pages/MarketingPage";
import OrdersPage from "./pages/OrdersPage";
import ProductionPage from "./pages/ProductionPage";
import ProfilePage from "./pages/ProfilePage";
import ChangePasswordPage from "./pages/ChangePasswordPage";
import WhatsAppHubPage from "./pages/WhatsAppHubPage";

const qclient = new QueryClient({
  defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: false } },
});

export default function App() {
  return (
    <QueryClientProvider client={qclient}>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/initial-setup" element={<InitialSetupPage />} />
          <Route path="/setup" element={<InitialSetupPage />} />
          <Route path="/accept-invitation" element={<AcceptInvitationPage />} />
          <Route path="/change-password" element={<ChangePasswordPage />} />
          <Route element={<AppShell />}>
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/follow-ups" element={<FollowUpsPage />} />
            <Route path="/whatsapp" element={<WhatsAppHubPage />} />
            <Route path="/orders" element={<OrdersPage />} />
            <Route path="/production" element={<ProductionPage />} />
            <Route path="/delivery" element={<DispatchPage />} />
            <Route path="/accounts" element={<FinancePage />} />
            <Route path="/marketing" element={<MarketingPage />} />
            <Route path="/intelligence" element={<IntelligencePage />} />
            <Route path="/calendar" element={<CalendarPage />} />
            <Route path="/customers" element={<CustomersPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
